import type {RouteRecordRaw} from "vue-router";
import IconTrashStatus from '@/app/assets/icons/document_trash.vue';

export const routeName = 'Trash';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'trash',
    redirect: {
        name: 'TrashList',
    },
    meta: {
        title: 'status_trash',
        icon: IconTrashStatus,
        isNavTab: true,
    },
    children: [
        {
            name: 'TrashList',
            path: '',
            component: () => import('@/pages/DocumentList'),
            props: {
                status: 'trash',
            },
            meta: {
                isHide: true,
                title: 'status_trash'
            }
        },
        {
            name: 'TrashDoc',
            path: ':id',
            component: () => import('@/pages/Trash'),
            props: true,
            meta: {
                isHide: true,
                title: 'status_trash'
            }
        }
    ]
};
